import * as React from 'react'
import { Platform, TouchableOpacity, View } from 'react-native'
import Svg, {
  SvgProps,
  Defs,
  RadialGradient,
  Stop,
  LinearGradient,
  Path,
  Text,
  TSpan,
  G,
  Use,
  Circle,
  Rect,
} from 'react-native-svg'
import ColoredText from '../../CustomText/ColoredText'
/* SVGR has dropped some elements not supported by react-native-svg: title, filter */
const AR_1 = ({
  props,
  shops,
  selectShop,
  year,
  onClose,
}: {
  props?: SvgProps
  shops: Array<string> | null
  selectShop: (shop: string) => void
  year: string
  onClose: () => Promise<void>
}) => {
  return (
    <>
      <Svg width={393} height={852} {...props}>
        <Defs>
          <RadialGradient
            id="c"
            cx="50%"
            cy="2.498%"
            r="84.551%"
            fx="50%"
            fy="2.498%"
            gradientTransform="matrix(0 .9796 -1 0 .525 -.465)"
          >
            <Stop offset="0%" stopColor="#FDCE21" />
            <Stop offset="100%" stopColor="#FDA500" />
          </RadialGradient>
          <RadialGradient
            id="g"
            cx="50%"
            cy="100%"
            r="222.877%"
            fx="50%"
            fy="100%"
            gradientTransform="matrix(0 -1 .2143 0 .286 1.5)"
          >
            <Stop offset="0%" stopColor="#FFF" />
            <Stop offset="100%" stopColor="#FBEFC5" />
          </RadialGradient>
          <RadialGradient
            id="i"
            cx="50%"
            cy="2.498%"
            r="84.551%"
            fx="50%"
            fy="2.498%"
            gradientTransform="matrix(0 .9796 -1 0 .525 -.465)"
          >
            <Stop offset="0%" stopColor="#FDCE21" />
            <Stop offset="100%" stopColor="#FDA500" />
          </RadialGradient>
          <RadialGradient
            id="m"
            cx="50%"
            cy="100%"
            r="222.877%"
            fx="50%"
            fy="100%"
            gradientTransform="matrix(0 -1 .2143 0 .286 1.5)"
          >
            <Stop offset="0%" stopColor="#FFF" />
            <Stop offset="100%" stopColor="#FBEFC5" />
          </RadialGradient>
          <LinearGradient id="e" x1="0%" x2="100%" y1="45.033%" y2="45.033%">
            <Stop offset="0%" stopColor="#FDC61A" stopOpacity={0} />
            <Stop offset="75.626%" stopColor="#FDC61A" stopOpacity={0.711} />
            <Stop offset="100%" stopColor="#E09200" />
          </LinearGradient>
          <LinearGradient id="k" x1="0%" x2="100%" y1="45.033%" y2="45.033%">
            <Stop offset="0%" stopColor="#FDC61A" stopOpacity={0} />
            <Stop offset="75.626%" stopColor="#FDC61A" stopOpacity={0.711} />
            <Stop offset="100%" stopColor="#E09200" />
          </LinearGradient>
          <Path
            id="d"
            d="M25.633 0h102.53c14.157 0 25.633 11.099 25.633 24.79v107.42c0 13.691-11.476 24.79-25.633 24.79H25.633C11.476 157 0 145.901 0 132.21V24.79C0 11.098 11.476 0 25.633 0Z"
          />
          <Path
            id="j"
            d="M18.5 0h74C102.717 0 111 8.01 111 17.891v77.53c0 9.881-8.283 17.891-18.5 17.891h-74c-10.217 0-18.5-8.01-18.5-17.89v-77.53C0 8.01 8.283 0 18.5 0Z"
          />
          <Text
            id="b"
            fill="#F4F5F9"
            fontFamily={'Comfortaa_700Bold'}
            fontSize={80}
            fillRule={Platform.OS !== 'android' ? 'nonzero' : 'evenodd'}
          >
            <TSpan x={100} y={378}>
              {year}
            </TSpan>
          </Text>
        </Defs>
        <G fill="none" fillRule="evenodd">
          <Path fill="#73147C" d="M0 0h393v852H0z" />
          <Text
            fill="#F4F5F9"
            fontFamily={'Comfortaa_700Bold'}
            fontSize={30}
            fillRule={Platform.OS !== 'android' ? 'nonzero' : 'evenodd'}
          >
            <TSpan x={70} y={290}>
              {'Jahresr\xFCckblick'}
            </TSpan>
          </Text>
          <G fill="#F4F5F9" fillRule="nonzero">
            <Use xlinkHref="#b" />
            <Use xlinkHref="#b" />
          </G>
          <Path stroke="#FFF" strokeWidth={3} d="M45.465 285v-49h50M334.465 349v49h-50" />
          <G transform="translate(351 50)" onPress={onClose}>
            <Circle cx={14.5} cy={14.5} r={14.5} fill="#1E2239" />
            <Path
              fill="#FFF"
              fillRule="nonzero"
              d="M21.711 21.228a1.25 1.25 0 1 1-1.92 1.6l-5.29-6.38-5.29 6.347a1.247 1.247 0 0 1-1.76.16 1.25 1.25 0 0 1-.16-1.76l5.582-6.7L7.29 7.83a1.25 1.25 0 1 1 1.92-1.6l5.29 6.346 5.29-6.348a1.249 1.249 0 1 1 1.92 1.6l-5.583 6.7 5.584 6.7Z"
            />
          </G>
          <G transform="rotate(36 -794.586 280.267)">
            <Use xlinkHref="#d" fill="url(#c)" />
            <Use xlinkHref="#d" fill="url(#e)" />
          </G>
          <Path
            fill="#CF8A03"
            d="M21.595 112.143h107.402c10.157 0 18.39 8.607 18.39 19.224 0 10.618-8.233 19.225-18.39 19.225H21.595c-10.157 0-18.39-8.607-18.39-19.225 0-10.617 8.233-19.224 18.39-19.224Z"
            //   filter="url(#f)"
            opacity={0.253}
            transform="rotate(36 -794.586 280.267)"
          />
          <Path
            fill="#FFF"
            d="m-35.083 628.226 84.96 61.727c8.034 5.837 9.91 16.952 4.19 24.826-5.722 7.874-16.872 9.525-24.907 3.687L-55.8 656.74c-8.034-5.838-9.91-16.953-4.189-24.827 5.72-7.873 16.872-9.524 24.906-3.687Z"
          />
          <Path
            fill="url(#g)"
            d="M26.777 118.551h100.242c9.48 0 17.165 6.455 17.165 14.418 0 7.963-7.685 14.419-17.165 14.419H26.777c-9.48 0-17.165-6.456-17.165-14.419s7.685-14.418 17.165-14.418Z"
            transform="rotate(36 -794.586 280.267)"
          />
          <G filter="url(#h)" transform="rotate(12 -388.502 1600.322)">
            <Use xlinkHref="#j" fill="url(#i)" />
            <Use xlinkHref="#j" fill="url(#k)" />
            <Path
              fill="#CF8A03"
              d="M15.586 80.938h77.516c7.33 0 13.273 6.212 13.273 13.874 0 7.663-5.943 13.876-13.273 13.876H15.586c-7.33 0-13.274-6.213-13.274-13.876 0-7.662 5.943-13.874 13.274-13.874Z"
              // filter="url(#l)"
              opacity={0.253}
            />
            <Path
              fill="#FFF"
              d="M17.603 83.25h75.794c7.167 0 12.978 5.694 12.978 12.719 0 7.024-5.81 12.719-12.978 12.719H17.603c-7.167 0-12.978-5.695-12.978-12.72 0-7.024 5.81-12.718 12.978-12.718Z"
            />
            <Path
              fill="url(#m)"
              d="M19.326 85.563h72.348c6.842 0 12.388 4.659 12.388 10.406 0 5.747-5.546 10.406-12.388 10.406H19.326c-6.842 0-12.389-4.659-12.389-10.406 0-5.747 5.547-10.406 12.389-10.406Z"
            />
          </G>
          <G transform="translate(10 61.596)">
            <Path
              fill="#FFF"
              fillRule="nonzero"
              d="M270.5 458.654h10.687a.51.51 0 0 0 .399-.188.624.624 0 0 0 .164-.422 10.913 10.913 0 0 0-1.594-5.203 11.31 11.31 0 0 0-3.844-3.843 10.913 10.913 0 0 0-5.203-1.594.624.624 0 0 0-.422.164.51.51 0 0 0-.187.398v10.688Zm12.422 2.25h-10.688l7.547 7.547c.125.125.266.18.422.164a.684.684 0 0 0 .422-.211 10.983 10.983 0 0 0 2.039-3.235c.484-1.187.758-2.406.82-3.656a.624.624 0 0 0-.164-.422.51.51 0 0 0-.398-.187Zm-7.125 6.797-7.547-7.547v-10.688a.51.51 0 0 0-.188-.398.624.624 0 0 0-.421-.164 11.3 11.3 0 0 0-5.344 1.71 11.195 11.195 0 0 0-3.867 4.055c-.953 1.688-1.43 3.532-1.43 5.532s.508 3.859 1.523 5.578a11.465 11.465 0 0 0 4.102 4.101c1.719 1.016 3.594 1.524 5.625 1.524a11.175 11.175 0 0 0 7.547-2.907.595.595 0 0 0 .164-.374.506.506 0 0 0-.164-.422ZM60.5 378.654h10.687a.51.51 0 0 0 .399-.188.624.624 0 0 0 .164-.422 10.913 10.913 0 0 0-1.594-5.203 11.31 11.31 0 0 0-3.844-3.843 10.913 10.913 0 0 0-5.203-1.594.624.624 0 0 0-.422.164.51.51 0 0 0-.187.398v10.688Zm12.422 2.25H62.234l7.547 7.547c.125.125.266.18.422.164a.684.684 0 0 0 .422-.211 10.983 10.983 0 0 0 2.039-3.235c.484-1.187.758-2.406.82-3.656a.624.624 0 0 0-.164-.422.51.51 0 0 0-.398-.187Zm-7.125 6.797-7.547-7.547v-10.688a.51.51 0 0 0-.188-.398.624.624 0 0 0-.421-.164 11.3 11.3 0 0 0-5.344 1.71 11.195 11.195 0 0 0-3.867 4.055c-.953 1.688-1.43 3.532-1.43 5.532s.508 3.859 1.523 5.578a11.465 11.465 0 0 0 4.102 4.101c1.719 1.016 3.594 1.524 5.625 1.524a11.175 11.175 0 0 0 7.547-2.907.595.595 0 0 0 .164-.374.506.506 0 0 0-.164-.422ZM141.571 44.975a2.572 2.572 0 0 1 2.572-2.571h1.714a2.572 2.572 0 0 1 2.572 2.571v18.857a2.572 2.572 0 0 1-2.572 2.572h-1.714a2.572 2.572 0 0 1-2.572-2.572V44.975ZM133 55.261a2.572 2.572 0 0 1 2.571-2.572h1.715a2.572 2.572 0 0 1 2.571 2.572v8.571a2.572 2.572 0 0 1-2.571 2.572h-1.715A2.572 2.572 0 0 1 133 63.832v-8.571Zm21.429-9.429A2.572 2.572 0 0 1 157 48.404v15.428a2.572 2.572 0 0 1-2.571 2.572h-1.715a2.572 2.572 0 0 1-2.571-2.572V48.404a2.572 2.572 0 0 1 2.571-2.572h1.715ZM324.571 624.975a2.572 2.572 0 0 1 2.572-2.571h1.714a2.572 2.572 0 0 1 2.572 2.571v18.857a2.572 2.572 0 0 1-2.572 2.572h-1.714a2.572 2.572 0 0 1-2.572-2.572v-18.857ZM316 635.261a2.572 2.572 0 0 1 2.571-2.572h1.715a2.572 2.572 0 0 1 2.571 2.572v8.571a2.572 2.572 0 0 1-2.571 2.572h-1.715a2.572 2.572 0 0 1-2.571-2.572v-8.571Zm21.429-9.429a2.572 2.572 0 0 1 2.571 2.572v15.428a2.572 2.572 0 0 1-2.571 2.572h-1.715a2.572 2.572 0 0 1-2.571-2.572v-15.428a2.572 2.572 0 0 1 2.571-2.572h1.715ZM141 614.578c0 .648-.552 1.174-1.232 1.174h-20.536c-.68 0-1.232-.48-1.232-1.174 0-.648.552-1.174 1.186-1.174h2.89c.346-2.63 2.387-4.752 5.056-5.322.289-.989 1.192-1.678 2.368-1.678h3.193c1.192 0 2.285.767 2.51 1.882.257 1.5-.898 2.77-2.417 2.77H129.5c-.68 0-1.296-.263-1.74-.641-1.642.33-2.894 1.522-3.22 2.989h15.228c.683 0 1.232.567 1.232 1.174Zm-20.536 2.74h18.072l-1.48 12.693c-.093.793-.805 1.393-1.642 1.393h-11.828c-.838 0-1.549-.6-1.641-1.393l-1.48-12.694Zm4.903 6.637 1.694 1.572-.397 2.226c-.078.403.372.703.744.513l2.092-1.052 2.092 1.052c.379.19.822-.11.744-.513l-.397-2.226 1.694-1.572a.486.486 0 0 0-.289-.837l-2.343-.33-1.046-2.025a.522.522 0 0 0-.918 0l-1.046 2.024-2.343.33a.485.485 0 0 0-.28.838ZM258 152.578c0 .648-.552 1.174-1.232 1.174h-20.536c-.68 0-1.232-.48-1.232-1.174 0-.648.552-1.174 1.186-1.174h2.89c.346-2.63 2.387-4.752 5.056-5.322.289-.989 1.192-1.678 2.368-1.678h3.193c1.192 0 2.285.767 2.51 1.882.257 1.5-.898 2.77-2.417 2.77H246.5c-.68 0-1.296-.263-1.74-.641-1.642.33-2.894 1.522-3.22 2.989h15.228c.683 0 1.232.567 1.232 1.174Zm-20.536 2.74h18.072l-1.48 12.693c-.093.793-.805 1.393-1.642 1.393h-11.828c-.838 0-1.549-.6-1.641-1.393l-1.48-12.694Zm4.903 6.637 1.694 1.572-.397 2.226c-.078.403.372.703.744.513l2.092-1.052 2.092 1.052c.379.19.822-.11.744-.513l-.397-2.226 1.694-1.572a.486.486 0 0 0-.289-.837l-2.343-.33-1.046-2.025a.522.522 0 0 0-.918 0l-1.046 2.024-2.343.33a.485.485 0 0 0-.28.838Z"
              opacity={0.292}
            />
            <Rect width={36.056} height={4.807} fill="#D8D8D8" rx={2.404} />
            <Rect width={36.056} height={4.807} x={42.065} fill="#D8D8D8" opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={84.13} fill="#D8D8D8" opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={126.195} fill="#D8D8D8" opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={167.659} fill="#D8D8D8" opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={209.711} fill="#D8D8D8" opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={250.827} fill="#D8D8D8" opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={291.944} fill="#D8D8D8" opacity={0.376} rx={2.404} />
          </G>
          {Platform.OS !== 'web' &&
            shops?.length > 1 &&
            shops?.map((shop, index) => {
              return (
                <>
                  <Rect
                    onPress={() => {
                      selectShop(shop)
                    }}
                    width={370}
                    height={40}
                    x={10}
                    y={450 + index * 45}
                    fill="#000"
                    fillRule="nonzero"
                    stroke="#383838"
                    strokeWidth={2}
                    rx={16}
                  />
                  <Text
                    fill="#F4F5F9"
                    fontFamily={'Comfortaa_500Medium'}
                    fontSize={18}
                    fillRule={Platform.OS !== 'android' ? 'nonzero' : 'evenodd'}
                  >
                    <TSpan x={20} y={475 + index * 45}>
                      {shop}
                    </TSpan>
                  </Text>
                </>
              )
            })}
        </G>
      </Svg>
      {Platform.OS === 'web' && (
        <>
          <TouchableOpacity
            onPress={onClose}
            style={{ position: 'absolute', top: 50, marginLeft: 330, width: 50, height: 50 }}
          />
          <View style={{ top: 450, position: 'absolute', flex: 1, flexDirection: 'column' }}>
            {shops?.length > 1 &&
              shops?.map((shop) => {
                return (
                  <TouchableOpacity
                    onPress={() => {
                      selectShop(shop)
                    }}
                    style={{
                      backgroundColor: `#000`,
                      padding: 6,
                      margin: 2,
                      borderRadius: 10,
                      width: 320,
                      height: 40,
                      alignContent: 'center',
                      alignItems: 'center',
                      flex: 1,
                      flexDirection: 'row',
                    }}
                  >
                    <ColoredText style={{ color: `#FFF`, fontSize: 16 }}>{shop}</ColoredText>
                  </TouchableOpacity>
                )
              })}
          </View>
        </>
      )}
    </>
  )
}
export default AR_1
